import { CUSTOMER_JOURNEY_NEWS_CATEGORIES, CUSTOMER_JOURNEY_NEWS_CATEGORIES_SUCCESS, CUSTOMER_JOURNEY_NEWS_CATEGORIES_ERROR } from '../../actions/const';
import { SET_TOKEN, SET_LANG } from '../../actions/const';

import CustomerJourneySource from '../../sources/CustomerJourneySource';
import defer from 'lodash/defer';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  apiData: [],
  loading: false
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case CUSTOMER_JOURNEY_NEWS_CATEGORIES: {
      const { token, lang, successCallback, errorCallback, context } = action
      nextState.loading = true;
      nextState.apiData = [];
      CustomerJourneySource.newsCategories(token, lang, successCallback, errorCallback, context);
      return nextState;
    }
    case CUSTOMER_JOURNEY_NEWS_CATEGORIES_SUCCESS: {
      const { data, successCallback } = action
      nextState.loading = false;
      nextState.apiData = data;
      if(successCallback) defer(successCallback, data);
      return nextState;
    }
    case CUSTOMER_JOURNEY_NEWS_CATEGORIES_ERROR: {
      const { errorCallback } = action
      nextState.loading = false;
      nextState.apiData = [];
      if(errorCallback) defer(errorCallback);
      return nextState;
    }
    case SET_TOKEN:
    case SET_LANG: {
      if(!isEmpty(state.apiData)) {
        const { token, lang, context } = action
        nextState.loading = true;
        nextState.apiData = [];
        CustomerJourneySource.newsCategories(token, lang, null, null, context);
        return nextState;
      }
      else {
        return state;
      }
    }
    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/newsCategories.js